import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {UncontrolledTooltip} from "reactstrap";
import {ReportSectionHeader} from "../SectionHeader";

const DollarValueInflationComponent = (props) => (
	<div>
		<ReportSectionHeader>
			<div id={"dollarValueInflationTitle"} className={"SectionHeaderInner"}>
				Maximum {props.isDandO === "true"?"Potential Damages" : "Artificial Inflation"} per Share {props.isDandO === "true"?" on Severe Adverse Events" : ""}
			</div>
			<UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
								 target={"dollarValueInflationTitle"}>

			{props.isDandO === "true"?
				"Potential damages per share of common stock if the corresponding adverse event is alleged as a corrective disclosure in a securities class action complaint or per the submitted inputs." :
				"Potential damages per share of common stock as presented in the corresponding securities class action complaint or per the commissioned inputs."
			}
			
			</UncontrolledTooltip>
		</ReportSectionHeader>
		<ReportTable
			settings={props.isDandO === "true"?[
				{header: 'Trading Day', accessor: 'date'},
				{
					header: 'Actual Stock Price Decline',
					accessor: 'actualStockDecline',
					dollarValue: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Maximum Potential Damages per Share',
					accessor: 'maxDollarOfArtificialInflationPerShare',
					round2Decimals: true,
					dollarValue: true,
					centerRightJustified: true,
					tooltip: 'Also known as Potential Damages per Share.'
				},
				{
					header: 'Attributable Artificial Inflation per Share',
					accessor: 'attributableArtificialInflationPerShare',
					tooltip: 'Attributable artificial inflation is equal to the damages per share based on a loss causation analysis to control the effects of potentially confounding information. In some cases, 100% of artificial inflation translates to damages per share but that cannot be determined without specialized analysis of loss causation.',
					style: {color: 'red'}
				}
			]
			:
			[
				{header: 'Trading Day', accessor: 'date'},
				{
					header: 'Actual Stock Price Decline',
					accessor: 'actualStockDecline',
					dollarValue: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Maximum Artificial Inflation per Share',
					accessor: 'maxDollarOfArtificialInflationPerShare',
					round2Decimals: true,
					dollarValue: true,
					centerRightJustified: true,
					tooltip: 'Also known as Potential Damages per Share.'
				},
				{
					header: 'Attributable Artificial Inflation per Share',
					accessor: 'attributableArtificialInflationPerShare',
					tooltip: 'Attributable artificial inflation is equal to the damages per share based on a loss causation analysis to control the effects of potentially confounding information. In some cases, 100% of artificial inflation translates to damages per share but that cannot be determined without specialized analysis of loss causation.',
					style: {color: 'red'}
				}
			]}
			data={props.dollarValueInflations}
			name={"dollarValueInflation"}
			accumulator={"maxDollarOfArtificialInflationPerShare"}
			accumulatorDisplay={"Damages Per Share"}
		/>
	</div>
);


export default DollarValueInflationComponent;


// WEBPACK FOOTER //
// ./src/common/components/DollarValueInflation/DollarValueInflationComponent.js